import React, { useRef } from 'react';
import Slider from 'react-slick';
import { motion } from 'framer-motion';
import './HeroSlider.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

// ✅ All 4 videos with their slide content
const videoSlides = [
  {
    id: 1,
    src: '/videos/video5.mp4',
    title: 'Modern Construction Excellence',
    subtitle: 'Building the Future, Today',
  },
  {
    id: 2,
    src: '/videos/vdieo2.mp4',
    title: 'Quality You Can Trust',
    subtitle: 'Delivering Projects On Time & On Budget',
  },
  {
    id: 3,
    src: '/videos/vdieo3.mp4',
    title: 'Expert Engineering Solutions',
    subtitle: 'From Foundation to Finish — We Build It Right',
  },
  {
    id: 4,
    src: '/videos/vdieo4.mp4',
    title: 'Your Vision, Our Expertise',
    subtitle: 'Transforming Ideas Into Remarkable Structures',
  },
];

const HeroSlider = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    pauseOnHover: false,
    fade: true,
    cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
    arrows: true,
    responsive: [
      {
        breakpoint: 768,
        settings: { arrows: false },
      },
    ],
  };

  return (
    <div className="hero-slider">
      <Slider {...settings}>
        {videoSlides.map((slide) => (
          <div key={slide.id} className="hero-slide">
            <div className="hero-video-slide">

              {/* Background Video */}
              <video
                autoPlay
                muted
                loop
                playsInline
                className="hero-bg-video"
              >
                <source src={slide.src} type="video/mp4" />
              </video>

              {/* Dark Overlay */}
              <div className="hero-overlay"></div>

              {/* Content */}
              <div className="hero-content-wrapper">
                <motion.div
                  className="hero-content"
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.2, ease: 'easeOut' }}
                >
                  <motion.h1
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.4, ease: 'easeOut' }}
                  >
                    {slide.title}
                  </motion.h1>

                  <motion.p
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.6, ease: 'easeOut' }}
                  >
                    {slide.subtitle}
                  </motion.p>

                  <motion.div
                    className="hero-buttons"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.8, ease: 'easeOut' }}
                  >
                    <a href="/contact" className="btn btn-primary btn-large">
                      Get Started
                    </a>
                    <a href="/projects" className="btn btn-outline btn-large">
                      View Projects
                    </a>
                  </motion.div>
                </motion.div>
              </div>

            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default HeroSlider;